export const SETDATATASK = 'SETDATATASK';
export const SETDATATASKPERWEEK = 'SETDATATASKPERWEEK';
export const UPDATETASKS = 'UPDATETASKS';
export const UPDATENOTIFICATION = 'UPDATENOTIFICATION';
export const SETDAYS = 'SETDAYS';
export const SETDATATASKEXPIRED = 'SETDATATASKEXPIRED';
